import { useState, useEffect } from 'react';
import { db, storage } from '../firebase';

import {
  doc, setDoc, onSnapshot
} from 'firebase/firestore';

import {
  ref,
  /* ★ */ uploadBytesResumable,
  getDownloadURL
} from 'firebase/storage';

const useFirebaseData = (user) => {
  const [animes,    setAnimes]    = useState([]);
  const [loading,   setLoading]   = useState(false);
  const [lastSync,  setLastSync]  = useState(null);

  /* ---------------- Firestore Sync ---------------- */
  useEffect(() => {
    if (!user) {
      setAnimes([]);
      return;
    }

    const userRef = doc(db, 'users', user.uid);

    const unsubscribe = onSnapshot(
      userRef,
      (docSnap) => {
        if (docSnap.exists()) {
          // ① Firestore から来た配列を取得
          const rawAnimes = docSnap.data().animes || [];

          // ② startEpisode などのデフォルトを補完
          const normalized = rawAnimes.map(a => ({
            startEpisode: a.startEpisode ?? 1,   // ← ここがポイント
            ...a                                   // 既存フィールドはそのまま
          }));

          // ③ state に反映
          setAnimes(normalized);
        } else {
          setAnimes([]);
        }
        setLastSync(new Date());
        setLoading(false);
      },
      (error) => {
        console.error('Error fetching data:', error);
        setLoading(false);
      }
    );

    return unsubscribe;
  }, [user]);

  /* ---------------- Save to Firestore ------------- */
  const saveData = async (newAnimes) => {
    if (!user) return;
    setLoading(true);

    try {
      const userRef = doc(db, 'users', user.uid);
      await setDoc(
        userRef,
        { animes: newAnimes, lastUpdated: new Date().toISOString() },
        { merge: true }
      );
      setLastSync(new Date());
    } catch (error) {
      console.error('Error saving data:', error);
      alert('データの保存中にエラーが発生しました');
    } finally {
      setLoading(false);
    }
  };

  /* ---------------- Upload to Storage ------------- */
  const uploadImage = async (file, path) => {
    console.log('★ uploadImage called', { file, path });
    if (!user || !file) return null;

    try {
      // ★ 1) パスに安全でない文字が混じると 404 になるので最低限サニタイズ
      const safePath = path.replace(/[^a-zA-Z0-9/_\-.]/g, '_');

      // ★ 2) Storage 参照を作成
      const storageRef = ref(storage, `users/${user.uid}/${safePath}`);

      // ★ 3) Resumable Upload で送信
      const metadata = { contentType: file.type && file.type.startsWith('image/')
                                      ? file.type
                                      : 'image/jpeg',           // ← デフォルトを補完
                        };
      const snapshot  = await uploadBytesResumable(storageRef, file, metadata);

      // 完了後にダウンロード URL を取得
      return await getDownloadURL(snapshot.ref);
    } catch (error) {
      console.error('Error uploading image:', error);
      return null;
    }
  };

  return { animes, saveData, uploadImage, loading, lastSync };
};

export default useFirebaseData;
